import { createTheme } from '@mui/material/styles';

// Define custom styles outside of createTheme
const customStyles = {
  customOpacity: {
    fontFamily: 'Sora medium',
    color: 'rgba(46, 43, 53, 0.5)',
  },
};

const theme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: 'rgba(255, 255, 255, 0)', // Use rgba instead of 'transparent'
      paper: '#FFFFFF',
    },
    primary: {
      main: '#539DEC',
    },
    secondary: {
      main: '#000000',
    },
    text: {
      primary: '#2E2B35',
      secondary: '#495057',
      hyperlink: '#D843FF',
    },
    action: {
      hover: 'rgba(216, 67, 255, 0.1)', // Use rgba instead of hex with alpha
    },
  },
  typography: {
    fontFamily: 'Sora, sans-serif',
    fontSize: 16,
    h1: {
      fontSize: '2.5rem',
      fontFamily: 'Sora medium, sans-serif',
    },
    body1: {
      fontFamily: 'Sora medium, sans-serif',
    },
    customOpacity: customStyles.customOpacity,
    hyperlink: {
      textDecoration: 'none',
      color: '#D843FF',
      '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
    navLink: {
      fontSize: '0.800rem',
      fontWeight: 550,
      letterSpacing: 0.5,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage: 'url("/images/LearnscapeBGhires.jpg")',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
          minHeight: '100vh',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: '#D9D9D9',
          borderWidth: '0.9px',
          borderStyle: 'solid',
        },
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: 'customOpacity' },
          style: customStyles.customOpacity,
        },
      ],
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#F4F4F4',
          borderRadius: '8px',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        },
        input: {
          padding: '12px 16px',
          color: '#000000',
          '&::placeholder': {
            color: 'rgba(46, 43, 53, 0.5)',
            opacity: 1,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputAdornment-root .MuiSvgIcon-root': {
            fontSize: '1.2rem',
          },
          '& .MuiInputBase-input::placeholder': {
            ...customStyles.customOpacity,
            opacity: 1,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '24px',
          textTransform: 'none',
          height: '48px',
          minWidth: '120px',
        },
        containedPrimary: {
          backgroundColor: '#000000', // Black background
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#333333', // Slightly lighter black on hover
          },
        },
        outlined: {
          borderColor: '#000000',
          color: '#000000',
          '&:hover': {
            borderColor: '#333333',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        },
        text: {
          color: '#000000',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          backgroundColor: '#FFFFFF',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
        },
      },
    },
  },
});

export default theme;




